import React from 'react';

import PropTypes from 'prop-types';

import './tree.less';

function Tree({data = [], callbackOnClick}) {
  // ConsoleLog("Tree", data);
  return (
    <div className="d-tree">
      <ul className="d-flex d-tree-container flex-column">
        {data.map((tree) => (
          <TreeNode
            node={tree}
            callbackOnClick={callbackOnClick}
            key={tree.key}
          />
        ))}
      </ul>
    </div>
  );
}

Tree.propTypes = {
  data: PropTypes.array,
  callbackOnClick: PropTypes.func,
};

Tree.defaultProps = {
  callbackOnClick: () => {},
  data: [],
};

function TreeNode({node, callbackOnClick}) {
  // const [childVisible, setChildVisiblity] = useState(false);

  const hasChild = !!node.children;
  // ConsoleLog("TreeNode", node);

  return (
    <li className="d-tree-node border-0">
      <div
        className={node.isActive ? 'd-flex activeFolder ' : 'd-flex '}
        onClick={() => {
          // setChildVisiblity((v) => !v);
          callbackOnClick(node);
        }}
      >
        {hasChild && (
          <div className={node.isActive ? 'd-inline d-tree-toggler activeFolderToggler' : 'd-inline d-tree-toggler'}>
            {!node.childVisible ? (
              <img
                alt={node.icon}
                src={node.icon}
                disabled
              />
            ) : (
              <img
                alt={node.hasChildIcon}
                src={node.hasChildIcon}
                disabled
              />
            )}
          </div>
        )}
        <div className="col d-tree-head">
          {/* <i className={`mr-1 ${node.icon}`}> </i> */}
          {node.label}
        </div>
      </div>

      {hasChild && node.childVisible && (
        <div className="d-tree-content">
          <ul className="d-flex d-tree-container flex-column">
            <Tree
              data={node.children}
              callbackOnClick={callbackOnClick}
            />
          </ul>
        </div>
      )}
    </li>
  );
}

TreeNode.propTypes = {
  node: PropTypes.object,
  callbackOnClick: PropTypes.func,
};

TreeNode.defaultProps = {
  callbackOnClick: () => {},
  node: {},
};

export default Tree;
